import ImageWMS from 'ol/source/ImageWMS';
import {
  DEFAULT_LIGHT_CONDITION, LAYERS_PARAM, LIGHT_CONDITION_PARAM, WMS_VERSION_PARAM, DEFAULT_WMS_VERSION,
} from './GeomodSourceUtils';
// import { tileLoader } from '../utils/httpRequest';
import { LAYERS_PARAMETERS_UPDATED_EVENT_TYPE } from '../utils/events.js'

/**
 * @typedef {Object} GeomodImageWMSOptions
 * @property {string} [light] The initial light condition of the layer. Default: DAY
 * @property {string} name The layer name.
 * @property {string} url The url endpoint to request.
 * @property {string} [version] The WMS protocole version. Default: 1.3.0
 * @property {Map<string,string>} [extraParameters] The extra parameters for the request exemple: AIS_SHOW_TRACE=false.
 */

/**
 * The Geomod image WMS source.
 * @extends {ImageWMS}
 */
export default class GeomodImageWMS extends ImageWMS {
  /**
     * @constructor
     * @param {GeomodImageWMSOptions} options The object options.
     */
  constructor(options = {}) {
    let extraParametersOptions;
    if (options.extraParameters) {
      extraParametersOptions = {};
      const extraParameters = JSON.parse(localStorage.getItem('layerExtraParameters')) || {};
      for (const key of options.extraParameters) {
        extraParametersOptions[key] = extraParameters[key];
      }
    }
    const superParams = {
      interpolate: false,
      url: options.url,
      params: {
        ...extraParametersOptions,
        [LAYERS_PARAM]: options.name,
        [LIGHT_CONDITION_PARAM]: options.light || DEFAULT_LIGHT_CONDITION,
        [WMS_VERSION_PARAM]: DEFAULT_WMS_VERSION,
        token: localStorage.getItem('token')
      },
      // imageLoadFunction: tileLoader
    }

    const requestOptions = localStorage.getItem('requestOptions')
    if (requestOptions && requestOptions !== 'null' && Object.keys(JSON.parse(requestOptions)).length > 0) {
      superParams.params = { ...superParams.params, ...JSON.parse(requestOptions) };
    }

    super(superParams);

    let previousParameterchange;

    if (extraParametersOptions) {
      document.addEventListener(LAYERS_PARAMETERS_UPDATED_EVENT_TYPE, (e) => {
        const updateParams = {};
        const extraParameters = JSON.parse(localStorage.getItem('layerExtraParameters')) || {};
        for (const key in extraParametersOptions) {
          if (e.detail.parameters.includes(key)) {
            updateParams[key] = extraParameters[key];
          }
        }
        if (Object.keys(updateParams).length > 0) {
          if (previousParameterchange) {
            clearTimeout(previousParameterchange);
          } else {
            this.updateParams(updateParams);
          }
          previousParameterchange = setTimeout(() => {
            this.updateParams(updateParams);
            previousParameterchange = undefined;
          }, 200);
        }
      });        
    }

    /**
         * The source tag
         * @private
         * @type {string}
         */
    this.tag_ = options.filter;
  }

  /**
     * Get the source tag.
     * @return {string} The source tag.
     */
  getTag() {
    return this.tag_;
  }

  /**
     * Refresh the layer by update ts param. A new map request will be launch.
     */
  refresh() {
    this.updateParams({ ts: new Date().getTime() });
  }
}
